import { appConfig, getAuthToken, getCompanyId } from '$utils'
import { CoreApiClient } from '@loadedhub/core-api-sdk'

// Note that as this client is a singleton, instantiated once when then app is
// loaded, we need to make sure that properties that can change are functions
// that return the current value.
const coreApiClient = new CoreApiClient(
  {
    authToken: () => getAuthToken(),
    companyId: () => getCompanyId(),
  },
  appConfig.get<string>('mercuryApiUrl')
)

export default coreApiClient

/**
 * Creates a new CoreApiClient that is specific to a venue.
 *
 * @param venueId The venue id to create the client for
 * @returns A new CoreApiClient that is specific to the venue
 */
export function createVenueSpecificClient(venueId: string) {
  return new CoreApiClient(
    {
      authToken: () => getAuthToken(),
      companyId: () => venueId,
    },
    appConfig.get<string>('mercuryApiUrl')
  )
}
